export default {"src":"/_next/static/media/last-child-branch.200bb7ae.svg","height":32,"width":32};